module.exports = __webpack_public_path__ + "img/height.4a6454c2.svg";